import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-retask-options-dialog',
  templateUrl: './retask-options-dialog.component.html',
  styleUrls: ['./retask-options-dialog.component.scss'],
})
export class RetaskOptionsDialogComponent {
  selectedMode: 'existing-sensor' | 'different-sensors' = 'existing-sensor';

  constructor(
    private dialogRef: MatDialogRef<RetaskOptionsDialogComponent, 'existing-sensor' | 'different-sensors'>,
    @Inject(MAT_DIALOG_DATA) public data: { darkTheme: boolean; taskName?: string; sensorName?: string }
  ) {}

  selectMode(mode: 'existing-sensor' | 'different-sensors'): void {
    this.selectedMode = mode;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  continue(): void {
    this.dialogRef.close(this.selectedMode);
  }
}